import { requests } from "../../../../api/agent"

export default {
	create                : (params) => requests.post('/reBuildType/create', params),
	update                : (params) => requests.post('/reBuildType/update', params),
	delete                : (params) => requests.getWithParams('/reBuildType/delete', params),
	restore               : (params) => requests.getWithParams('/reBuildType/restore', params),
	getPaged              : (params) => requests.getWithParams('/reBuildType/getPaged', params),
    getPagedAll           : (params) => requests.getWithParams('/reBuildType/getPagedAll', params),
	getPagedAudit         : (params) => requests.getWithParams('/reBuildType/getPagedAudit', params),
	getBuildTypes	  	  : (params) => requests.getWithParams('/reBuildType/getBuildTypes', params)
}